import { Spin } from "antd";
import { useDocumentContent } from "../../../hooks/document-content/use-document-content";
import TreeList, { Column, RemoteOperations, Scrolling } from "devextreme-react/tree-list";
import { SharePointPermissionRole } from "../../../../../constants/sharePointConstant";
import { useUser } from "../../../../../hook";
import { IDocumentContent } from "../../../../../models/IDocumentContent";
import { useDocumentInfo } from "../../../hooks/documents/use-document-info";
import { isEqualBetweenSharepointUserAndLoginUser } from "../../../../../services/util";
import { useFilePermission } from "../../../hooks/use-file-permission";
import { ISharepointLink, ISharepointUser } from "../../../../../models/ISharepoint";
import { useSearchParams } from "../../../../../hook/use-search-params";
import { documentStatus } from "../../../../../constants";
import { Employee } from "../../../../../services/department-viags/employee-viags.service";
import { Badge } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useDocumentTags } from "../../../../setting/document/document-tags/hooks/useDocumentTags";

export const EditorContentInProcess = () => {
  const { mappedData, isLoading } = useDocumentContent();
  const { data: fileShareLinks } = useFilePermission();
  const { data: documentInfo } = useDocumentInfo();
  const { user, checkCurrentUser, email, name } = useUser();
  const isOwner = checkCurrentUser(documentInfo?.userEmail?.toLowerCase() || "");
  const { searchParams } = useSearchParams();
  const isPublishStatus = searchParams.get("status") === documentStatus.publish.value;
  const history = useHistory();
  const { getTagLabel } = useDocumentTags();

  const checkPermissionFromShareLinks = (shareLinks: Array<ISharepointLink>, userLogin: any) => {
    if (!shareLinks || shareLinks.length === 0) {
      return SharePointPermissionRole.read;
    }

    const links = shareLinks.filter(
      (l: ISharepointLink) =>
        !l.users ||
        l.users.length === 0 ||
        l.users.find((u: ISharepointUser) => isEqualBetweenSharepointUserAndLoginUser(u, userLogin)),
    );

    let roles: Array<string> = [];
    links.forEach((l: ISharepointLink) => {
      l.roles?.forEach((r) => roles.push(r));
    });

    if (roles.find((l) => l === SharePointPermissionRole.write)) {
      return SharePointPermissionRole.write;
    }

    if (roles.find((l) => l === SharePointPermissionRole.read)) {
      return SharePointPermissionRole.read;
    }

    return SharePointPermissionRole.none;
  };

  const checkPermission = (data: IDocumentContent, userLogin: any) => {
    if (user.isMasterUser) return SharePointPermissionRole.write;

    if (isOwner) return SharePointPermissionRole.write;

    //Check shareLinks are defined or not.
    //if yes, check permission
    if (
      isEqualBetweenSharepointUserAndLoginUser(data.CreatedUser, userLogin) === true ||
      isEqualBetweenSharepointUserAndLoginUser(data.ModifiedUser, userLogin) === true
    ) {
      return SharePointPermissionRole.write;
    }

    if (!data || !data.ShareLinks || data.ShareLinks.length === 0) {
      if (fileShareLinks && fileShareLinks.length > 0) {
        return checkPermissionFromShareLinks(fileShareLinks, userLogin);
      } else {
        return SharePointPermissionRole.none;
      }
    }

    return checkPermissionFromShareLinks(data.ShareLinks, userLogin);
  };

  const checkReviewers = () => {
    if (!documentInfo || documentInfo?.docReviewers?.toString() === "[]") return false;
    if (isOwner) return true;
    return documentInfo.docReviewers?.find((u: any) => u.Id === user.current.localAccountId) !== undefined;
  };

  const checkDetectors = () => {
    if (!documentInfo || documentInfo?.docDetectors?.toString() === "[]") return false;
    if (isOwner) return true;
    return documentInfo.docDetectors?.find((u: any) => u.Id === user.current.localAccountId) !== undefined;
  };

  const checkCheckers = () => {
    if (!documentInfo || documentInfo.docCheckers?.toString() === "[]") return false;
    if (isOwner) return true;
    return documentInfo.docCheckers?.find((u: any) => u.Id === user.current.localAccountId) !== undefined;
  };

  const checkApprovers = () => {
    const docApproved = documentInfo?.approvedBy ? JSON.parse(documentInfo.approvedBy) : [];
    if (!documentInfo || documentInfo.approvedBy === "[]") return false;
    if (isOwner) return true;
    return docApproved?.find((u: any) => u.Id === user.current.localAccountId) !== undefined;
  };

  const contentCellRender = (cellInfo: any) => {
    var role = SharePointPermissionRole.read;
    if (cellInfo.data.IsContent) {
      role = checkPermission(cellInfo.data, user);
    }
    if (isOwner) {
      role = SharePointPermissionRole.write;
    }
    const id = `title-${cellInfo.data.Id}`;
    return (
      (role !== SharePointPermissionRole.none ||
        checkReviewers() ||
        checkDetectors() ||
        checkCheckers() ||
        checkApprovers() ||
        (isPublishStatus &&
          cellInfo.data.Permissions?.findIndex((e: Employee) => e.employeeEmail === email?.toLowerCase()) > -1)) && (
        <>
          {documentInfo?.userDisplayName === name && cellInfo.data.numberEdit > 0 ? (
            <div
              id={id}
              style={{ whiteSpace: "normal", padding: "1px", margin: "1px", color: "blue", userSelect: "none" }}
              className="scroll-mt-20"
              dangerouslySetInnerHTML={{ __html: cellInfo.value }}
            />
          ) : (
            <div
              id={id}
              style={{ whiteSpace: "normal", padding: "1px", margin: "1px", userSelect: "none" }}
              className="scroll-mt-20"
              dangerouslySetInnerHTML={{ __html: cellInfo.value }}
            />
          )}
          {/* <Tooltip id="my-tooltip" />; */}
        </>
      )
    );
  };

  if (isLoading) return <Spin />;

  return (
    <>
      <TreeList
        wordWrapEnabled={true}
        id="content__custom-editor"
        dataSource={mappedData}
        showRowLines={false}
        showBorders={true}
        columnAutoWidth={true}
        showColumnLines={false}
        allowColumnReordering={false}
        allowColumnResizing={false}
        keyExpr="CustomId"
        parentIdExpr="CustomParentId"
        autoExpandAll={true}
        showColumnHeaders={false}
      >
        <Scrolling mode="standard" />
        <RemoteOperations filtering={true} sorting={true} />
        <Column
          width="700px"
          fixed={true}
          fixedPosition="left"
          allowResizing={true}
          dataField="Content"
          alignment="left"
          allowSorting={false}
          dataType="string"
          cellRender={contentCellRender}
          cssClass="white-space: normal!important"
        />
      </TreeList>
      <div style={{ maxWidth: "1111px" }}>
        {documentInfo?.Tags?.map((tag: any, index: number) => (
          <Badge
            variant="secondary"
            className="mx-1 "
            key={index}
            style={{ whiteSpace: "normal", minWidth: 100, marginTop: "2px", cursor: "pointer" }}
            onClick={() => history.push(`/document?status=tags&tags=${tag?.label || tag.toString()}`)}
          >
            {getTagLabel(tag?.label || tag)}
          </Badge>
        ))}
      </div>
    </>
  );
};
